import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStudents } from '../../hooks/useStudents';
import StudentForm from '../../components/forms/StudentForm';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const StudentNew = () => {
  const navigate = useNavigate();
  const { addStudent } = useStudents();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    navigate('/students');
  };

  // Receives university_degree, mqa_recognition, moodle_access, remarks from StudentForm
  const handleStudentSubmit = async (formData) => {
    setLoading(true);
    try {
      const result = await addStudent(formData);
      if (!result?.success) {
        alert(result?.error || 'Failed to create student');
        return;
      }
      const created = result.data;
      alert('Student created. You can add enrollments next.');
      navigate(`/students/${created.id}?tab=enrollments`);
    } catch (e) {
      console.error('Error creating student:', e);
      alert('An unexpected error occurred while creating the student.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <Button
          variant="outline"
          onClick={handleCancel}
          className="flex items-center"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-1" />
          Back
        </Button>
        <h1 className="text-2xl font-bold text-gray-900">Add New Student</h1>
      </div>

      <Card>
        <div className="mb-4">
          <p className="text-sm text-gray-600">
            Create the student first. You’ll add subject enrollments from the student page.
          </p>
        </div>

        <StudentForm
          step={1}                 // Student info step (includes new fields)
          initialData={{}}         // no preset data on create
          onSubmit={handleStudentSubmit}
          onCancel={handleCancel}
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default StudentNew;
